import * as _ from 'underscore';
import { appStore } from '../../app/AppStore';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { FeatureFlags } from '../FeatureFlags';
import {
  DatabaseContentType,
  DataRoleContentType,
  DatasourceContentType,
  FlowContentType,
  IContentType,
  ProjectContentType,
  SiteUserContentType,
  TableContentType,
  ViewContentType,
  WorkbookContentType,
} from '../models/ContentTypes';
import { IViewBase } from '../models/IViewInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { Module } from '../Module';

export function getContentRootStateName(): string {
  // While home is still hidden behind a feature flag
  if (FeatureFlags.homePage) {
    return 'main.site.home';
  } else {
    return 'main.site.content.site.explore';
  }
}

// These are functions because sometimes the default subplace changes
// based on feature flags, and we have to figure that out at runtime
const PlaceStateForContentType: _.Dictionary<() => string> = {
  [ProjectContentType.name]: () => 'main.site.content.project',
  [WorkbookContentType.name]: () => 'main.site.content.workbook',
  [ViewContentType.name]: () => 'main.site.viz',
  [DatasourceContentType.name]: () => 'main.site.content.datasource',
  [SiteUserContentType.name]: () => 'main.site.user',
  [FlowContentType.name]: () => 'main.site.content.flow',
  [DataRoleContentType.name]: () => 'main.site.content.dataRole',
};

const DefaultSubplaceStateForContentType: _.Dictionary<() => string> = {
  [ProjectContentType.name]: () => '',
  [WorkbookContentType.name]: () => '',
  [ViewContentType.name]: () => '',
  [DatasourceContentType.name]: () => {
    return SessionSiteSelectors.isNLPServiceEnabled(appStore.getState()) ? '.nlp' : '.connections';
  },
  [SiteUserContentType.name]: () => '.workbooks',
  [FlowContentType.name]: () => '.overview',
  [DataRoleContentType.name]: () => '.definition',
  [TableContentType.name]: () => '',
  [DatabaseContentType.name]: () => ''
};

function getPlaceStateName(contentType: string) {
  const placeStateFn = PlaceStateForContentType[contentType];
  if (!_.isFunction(placeStateFn)) {
    throw new Error('State not known for ' + contentType);
  }
  return placeStateFn();
}

function getDefaultSubplaceStateName(contentType: string) {
  const subplaceStateFn = DefaultSubplaceStateForContentType[contentType];
  if (!_.isFunction(subplaceStateFn)) {
    throw new Error('Default State not known for ' + contentType);
  }
  return subplaceStateFn();
}


export function DefaultStateFor(contentType: string): string {
  const placeState = getPlaceStateName(contentType);
  const subplaceState = getDefaultSubplaceStateName(contentType);
  return placeState + subplaceState;
}

export class ContentUrl {

  public static $inject = ['$state'];

  constructor(private $state: ng.ui.IStateService) { }

  public forItem(item: any, itemType: IContentType, subplaceName?: string) {

    const baseStateName = getPlaceStateName(itemType.name);
    const subplaceStateName = subplaceName ? ('.' + subplaceName)
      : getDefaultSubplaceStateName(itemType.name);
    const stateName = baseStateName + subplaceStateName;

    // Views are keyed by path, all other content types are keyed by ID
    const stateParams = (itemType.name === ViewContentType.name)
      ? { path: (<IViewBase>item).path }
      : { id: (<INamedItemInfo>item).id };

    return this.$state.href(stateName, stateParams);
  }

}

Module.instance().service('ContentUrl', ContentUrl);
